import type { SVGProps } from "react";

export function XCrossIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function XCrossCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8L8 16M8 8L16 16M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function XCrossCircleFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C13.3132 2 14.6138 2.25917 15.827 2.76172C17.0402 3.26426 18.1429 4.00011 19.0714 4.9286C19.9999 5.8571 20.7357 6.95985 21.2383 8.17296C21.7408 9.38622 22 10.6868 22 12C22 13.3132 21.7408 14.6138 21.2383 15.827C20.7357 17.0402 19.9999 18.1429 19.0714 19.0714C18.1429 19.9999 17.0402 20.7357 15.827 21.2383C14.6138 21.7408 13.3132 22 12 22C10.6868 22 9.38622 21.7408 8.17296 21.2383C6.95985 20.7357 5.8571 19.9999 4.9286 19.0714C4.00011 18.1429 3.26426 17.0402 2.76172 15.827C2.25917 14.6138 2 13.3132 2 12C2 10.6868 2.25917 9.38622 2.76172 8.17296C3.26426 6.95985 4.00011 5.8571 4.9286 4.9286C5.8571 4.00011 6.95985 3.26426 8.17296 2.76172C9.38622 2.25917 10.6868 2 12 2ZM16.1189 7.88108C15.685 7.44716 14.9817 7.44716 14.5477 7.88108L12 10.4288L9.45226 7.88108C9.01834 7.44716 8.31499 7.44716 7.88108 7.88108C7.44716 8.31499 7.44716 9.01834 7.88108 9.45226L10.4288 12L7.88108 14.5477C7.44716 14.9817 7.44716 15.685 7.88108 16.1189C8.315 16.5528 9.01837 16.5528 9.45226 16.1189L12 13.5712L14.5477 16.1189C14.9817 16.5528 15.685 16.5528 16.1189 16.1189C16.5528 15.685 16.5528 14.9817 16.1189 14.5477L13.5712 12L16.1189 9.45226C16.5528 9.01837 16.5528 8.315 16.1189 7.88108Z"
        fill="currentColor"
      />
    </svg>
  );
}
